import { AuthProvider } from "./models";
import auth0AuthProvider from "./providers/auth0.provider";

export function authProviderFactory(): AuthProvider {
  return window.azure || auth0AuthProvider;
}
